import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 bg-[#050508] text-center border-t border-brand-border" data-id="element-345">
      <div className="max-w-[800px] mx-auto" data-id="element-346">
        <div className="mb-8" data-id="element-347">
          <span className="text-white font-bold text-lg tracking-widest" data-id="element-348">
            🧬 BIO-X 90
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-muted mb-8" data-id="element-349">
          <a href="#" className="hover:text-white transition-colors" data-id="element-350">
            Términos
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-351">
            Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-352">
            Contacto
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-353">
            Soporte
          </a>
        </div>

        <div className="bg-brand-card/30 border border-brand-border/50 rounded-xl p-6 mb-8 text-left" data-id="element-354">
          <p className="text-xs text-brand-muted/70 leading-relaxed" data-id="element-355">
            <strong data-id="element-356">AVISO LEGAL IMPORTANTE:</strong> BIO-X 90 es un material
            educativo sobre hábitos, rendimiento y bienestar. No sustituye
            diagnóstico, tratamiento ni consejo médico profesional. Consulta con
            un profesional de salud antes de modificar alimentación,
            suplementación, sueño, ayuno o actividad física, especialmente si
            tienes condiciones médicas, tomas medicación o estás bajo
            tratamiento. Los resultados pueden variar.
          </p>
        </div>

        <p className="text-xs text-brand-muted/50 leading-relaxed max-w-[600px] mx-auto" data-id="element-357">
          © {new Date().getFullYear()} BIO-X 90. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}